import StaticPageLayout from "../components/StaticPageLayout";
import { COMPANY_PAGES } from "../data/companyPagesContent";

const AboutPage = () => (
  <StaticPageLayout page={COMPANY_PAGES.about} testId="about-page" />
);

export default AboutPage;
